module.exports = __webpack_public_path__ + "img/watch-membership.c141f73b.svg";